module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAcCAYAAAErT86QAAAAAXNSR0IArs4c6QAAAPJJREFUKBXtUiEOwkAQnD1IH4AjwYMCh66HD4BHg+ojqnhF+QD4ahwoPARcfZvQY+fauwQDFsEmvd7t7czO7h4QbJzYgakqHDHa2HvjHq6tNUYwF/oEWBm9yGuLvQtwXl2yKEJirMWiLHENlEI8T0RBBIXRZafBkxBM5oxIhtAMuZptizmnciNOvwexXaZVSJ/K3hIG2FdSYbmuWq3nspVl0EoOZnOamaEljam98KWrjqnPFv4/S+qFnbRrvSBXNyzJjYOt8Jemg5kvnD7eubl7ZP3EwTei9eX6OIC2qaluY57Vco6TE2yOH9a/SNec7518AROoyt+33DQeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/moreIcon/moreIcon.png
// module id = 126
// module chunks = 1